<mat-toolbar>
  <span class="pointer">Simulation Grossiste</span>
  <span class="spacer"></span>
  <app-filiale-selector></app-filiale-selector>
  <app-months-selector
    [availableMonths]="availableMonths"
    (onMonthsSelectionChange)="onMonthSelectionChange($event)"
    [selectedMonthsInput]="(selectedMonths$ | async) ?? []"
  >
  </app-months-selector>
  <app-years-selector
    [availableYears]="availableYears"
    [selectedYearInput]="selectedYear$.value"
    (onYearSelectionChange)="onYearSelectionChange($event)"
    isBorderless="true"
  ></app-years-selector>
  <app-officine-selector type="Remise_grossiste"></app-officine-selector>
</mat-toolbar>

<div class="main">
  @if (
    wholesalerSimulations$.value.length === 0 ||
    wholesalerSimulations$.value[0].simulations.length === 0
  ) {
    @if (activiteAdherent == 'gpo') {
      <div class="no-data">
        <span
          >Merci de contrôler que vous avez bien signé votre accord d'extraction de données. Cet
          accord est téléchargeable dans le module "Mes Autorisations".</span
        >
        <span
          >Merci de vérifier que les paramétrages de DIGIPHARMACIE sont corrects. Vous pouvez vous
          rapprocher de votre responsable de groupement si vous avez des questions.</span
        >
      </div>
    } @else {
      <div class="no-data">
        <span>Aucune remise grossiste trouvée</span>
      </div>
    }
  }
  <mat-tab-group class="wholesaler-tabs fixed-width-tabs" [animationDuration]="'150ms'">
    <mat-tab
      *ngFor="let simulation of wholesalerSimulations$ | async; trackBy: trackingKey"
      [label]="simulation.supplierName"
    >
      <app-wholesaler-table [wholesalerSimulation]="simulation"></app-wholesaler-table>
    </mat-tab>
  </mat-tab-group>
</div>
